import { useState } from 'react';
import Icon from './Icon';

/**
 * Section cout de revient — affichee dans les modals post-finalisation.
 *
 * Props :
 *   analytique  {object}  — reponse du backend : { cout_total_batch, cout_par_unite, deductions, avertissements }
 *   revenus     {number}  — revenus potentiels (pour calculer la marge brute)
 */
export default function CoutRevient({ analytique, revenus }) {
  const [showDetail, setShowDetail] = useState(false);

  if (!analytique || analytique.cout_total_batch == null) return null;

  const { cout_total_batch, cout_par_unite, deductions = [], avertissements } = analytique;

  const marge = revenus > 0
    ? Math.round((revenus - cout_total_batch) / revenus * 1000) / 10
    : null;

  const classMarge = marge === null ? '' : marge >= 40 ? 'success' : 'warning';

  return (
    <div className="card cout-revient">
      <h4>Cout de revient calcule</h4>

      <div className="cout-grid">
        <div className="cout-item">
          <span className="cout-label">Cout total matieres</span>
          <span className="cout-valeur accent">{cout_total_batch.toFixed(2)} $</span>
        </div>
        <div className="cout-item">
          <span className="cout-label">Cout par unite</span>
          <span className="cout-valeur">
            {cout_par_unite > 0 ? cout_par_unite.toFixed(4) + ' $' : '—'}
          </span>
        </div>
        {marge !== null && (
          <div className="cout-item">
            <span className="cout-label">Marge brute estimee</span>
            <span className={`cout-valeur ${classMarge}`}>
              {marge.toFixed(1)} %
            </span>
          </div>
        )}
      </div>

      {deductions.length > 0 && (
        <>
          <button
            className="cout-toggle"
            onClick={() => setShowDetail(v => !v)}
            type="button"
          >
            <Icon name={showDetail ? 'voir' : 'liste_puces'} size={12} />
            {showDetail ? 'Masquer la decomposition' : 'Decomposition du cout'}
          </button>

          {showDetail && (
            <table className="cout-table">
              <thead>
                <tr>
                  <th>Ingredient</th>
                  <th>Qte deduite</th>
                  <th>Prix unitaire</th>
                  <th>Cout</th>
                  <th>%</th>
                </tr>
              </thead>
              <tbody>
                {deductions.map(d => (
                  <tr key={d.matiere_id} className={d.prix_unitaire === 0 ? 'sans-prix' : ''}>
                    <td>{d.nom}</td>
                    <td>{d.quantite_deduite} {d.unite}</td>
                    <td>
                      {d.prix_unitaire > 0
                        ? `${d.prix_unitaire} $ / ${d.unite}`
                        : (
                          <span className="badge badge--warning">
                            <Icon name="attention" size={11} />
                            Prix non configure
                          </span>
                        )
                      }
                    </td>
                    <td>{d.cout_ingredient.toFixed(2)} $</td>
                    <td>
                      {cout_total_batch > 0
                        ? (d.cout_ingredient / cout_total_batch * 100).toFixed(1) + ' %'
                        : '—'
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td colSpan={3}><strong>TOTAL</strong></td>
                  <td><strong>{cout_total_batch.toFixed(2)} $</strong></td>
                  <td>100 %</td>
                </tr>
              </tfoot>
            </table>
          )}
        </>
      )}

      {avertissements && (
        <div className="avertissement-prix">
          <Icon name="attention" size={13} />
          {avertissements}
          <br />
          <small>Configurez les prix dans Inventaire — Matieres premieres pour un calcul complet.</small>
        </div>
      )}
    </div>
  );
}
